/**
 * A/B Test — Bundle pack messaging (all 3 packs visible)
 * Toggle: body[data-bundle-messaging-3pack-ab="true|false"]
 *   - false (control): default 1 / 2 / 4 Pack labels
 *   - true  (variant): show all 3 packs
 *       1 Pack → "1 Pack"
 *       2 Pack → "Buy 1 Get 1 FREE"
 *       4 Pack → "Buy 2 Get 2 FREE"
 *
 * Diff vs bundle-messaging-ab-test.js: 1 Pack stays visible.
 * Skipped when data-bundle-selector-ab or data-bundle-messaging-ab is true.
 */
(function () {
  'use strict';

  if (window.__bundleMessaging3packAbInit) return;
  window.__bundleMessaging3packAbInit = true;

  var ATTR = 'data-bundle-messaging-3pack-ab';
  var PACK_ATTR = 'data-pack-type';
  var ORIGINAL_ATTR = 'data-bundle-messaging-3pack-ab-original';
  var BADGE_ORIGINAL_ATTR = 'data-bundle-messaging-3pack-ab-badge-original';
  var VARIANT_B_BADGE = '50% OFF';
  var LABELS = {
    '1': '1 Pack',
    '2': 'Buy 1 Get 1 FREE',
    '4': 'Buy 2 Get 2 FREE'
  };
  var timer = null;
  var applying = false;
  var lastEnabled = null;
  var lastKachingInteraction = 0;

  function isAbEnabled() {
    if (!document.body) return false;
    var bodyVal = document.body.getAttribute(ATTR);
    if (bodyVal === 'true') return true;
    if (bodyVal === 'false') return false;
    return document.body.getAttribute('data-bundle-messaging-3pack-ab-setting') === 'true';
  }

  function isConflictingTest() {
    if (!document.body) return false;
    return document.body.getAttribute('data-bundle-selector-ab') === 'true' ||
      document.body.getAttribute('data-bundle-messaging-ab') === 'true';
  }

  function hasKachingBundles() {
    return document.querySelectorAll('.kaching-bundles__bar').length > 0;
  }

  function normalize(text) {
    return String(text || '').replace(/\s+/g, ' ').trim();
  }

  function detectPackType(text) {
    var n = normalize(text).toLowerCase();
    if (n.indexOf('buy 2 get 2') > -1) return '4';
    if (n.indexOf('buy 1 get 1') > -1) return '2';
    if (/\b4\s*pack\b/.test(n)) return '4';
    if (/\b2\s*pack\b/.test(n)) return '2';
    if (/\b1\s*pack\b/.test(n)) return '1';
    return null;
  }

  function getKachingTitleEl(bar) {
    return bar.querySelector('.kaching-bundles__bar-title') ||
      bar.querySelector('[class*="bar-title"]:not([class*="bar-label"])');
  }

  function getSwatchTitleEl(swatch) {
    return swatch.querySelector('.bundletitle');
  }

  function getDiscountBadge(node) {
    if (!node) return null;

    var badges = node.querySelectorAll(
      '.discount-percentage, .igSavingsPercentage, .main-wrap-label, .green-badge, [class*="bar-badge"], [class*="bar-saving"]'
    );
    var i;
    var badge;

    for (i = 0; i < badges.length; i++) {
      badge = badges[i];
      if (badge.classList.contains('most-popular')) continue;
      if (/\d+%\s*OFF/i.test(normalize(badge.textContent))) return badge;
    }

    return null;
  }

  function applyDiscountBadges() {
    var nodes = [];

    document.querySelectorAll('.variant-picker__option .block-swatch[data-pack-type]').forEach(function (node) {
      nodes.push(node);
    });

    if (hasKachingBundles()) {
      document.querySelectorAll('.kaching-bundles__bar[data-pack-type]').forEach(function (node) {
        nodes.push(node);
      });
    }

    nodes.forEach(function (node) {
      var packType = node.getAttribute(PACK_ATTR);
      if (!packType || packType === '1') return;

      var badge = getDiscountBadge(node);
      if (!badge) return;

      if (!badge.getAttribute(BADGE_ORIGINAL_ATTR)) {
        badge.setAttribute(BADGE_ORIGINAL_ATTR, normalize(badge.textContent));
      }
      if (normalize(badge.textContent) !== VARIANT_B_BADGE) {
        badge.textContent = VARIANT_B_BADGE;
      }
    });
  }

  function restoreDiscountBadges() {
    document.querySelectorAll('[' + BADGE_ORIGINAL_ATTR + ']').forEach(function (badge) {
      var original = badge.getAttribute(BADGE_ORIGINAL_ATTR);
      if (original) badge.textContent = original;
      badge.removeAttribute(BADGE_ORIGINAL_ATTR);
    });
  }

  function getBarPackType(bar, index) {
    var stored = bar.getAttribute(PACK_ATTR);
    if (stored) return stored;

    var titleEl = getKachingTitleEl(bar);
    var fromText = titleEl ? detectPackType(titleEl.textContent) : null;
    if (fromText) return fromText;

    var bars = document.querySelectorAll('.kaching-bundles__bar');
    if (bars.length === 2) {
      return index === 0 ? '2' : '4';
    }

    return index === 0 ? '1' : index === 1 ? '2' : index === 2 ? '4' : null;
  }

  function tagPackNodes() {
    var bars = document.querySelectorAll('.kaching-bundles__bar');
    var i;
    var packType;

    for (i = 0; i < bars.length; i++) {
      packType = getBarPackType(bars[i], i);
      if (packType) bars[i].setAttribute(PACK_ATTR, packType);
    }

    document.querySelectorAll('.variant-picker__option').forEach(function (fieldset) {
      if (!fieldset.querySelector('.bundletitle')) return;
      fieldset.querySelectorAll('.block-swatch').forEach(function (swatch, index) {
        var titleEl = getSwatchTitleEl(swatch);
        var type = titleEl ? detectPackType(titleEl.textContent) : null;
        if (!type) {
          var count = fieldset.querySelectorAll('.block-swatch').length;
          if (count === 2) type = index === 0 ? '2' : '4';
          else type = index === 0 ? '1' : index === 1 ? '2' : index === 2 ? '4' : null;
        }
        if (type) swatch.setAttribute(PACK_ATTR, type);
      });
    });
  }

  function applyLabels() {
    if (hasKachingBundles()) {
      document.querySelectorAll('.kaching-bundles__bar[data-pack-type]').forEach(function (bar) {
        var packType = bar.getAttribute(PACK_ATTR);
        var label = LABELS[packType];
        var titleEl = getKachingTitleEl(bar);
        if (!label || !titleEl) return;

        if (!titleEl.getAttribute(ORIGINAL_ATTR)) {
          titleEl.setAttribute(ORIGINAL_ATTR, normalize(titleEl.textContent));
        }
        if (normalize(titleEl.textContent) !== label) {
          titleEl.textContent = label;
        }
      });
      return;
    }

    document.querySelectorAll('.variant-picker__option .block-swatch[data-pack-type]').forEach(function (swatch) {
      var packType = swatch.getAttribute(PACK_ATTR);
      var label = LABELS[packType];
      var titleEl = getSwatchTitleEl(swatch);
      if (!label || !titleEl) return;

      if (!titleEl.getAttribute(ORIGINAL_ATTR)) {
        titleEl.setAttribute(ORIGINAL_ATTR, normalize(titleEl.textContent));
      }
      if (normalize(titleEl.textContent) !== label) {
        titleEl.textContent = label;
      }
    });
  }

  function restoreLabels() {
    document.querySelectorAll('[' + ORIGINAL_ATTR + ']').forEach(function (el) {
      var original = el.getAttribute(ORIGINAL_ATTR);
      if (original) el.textContent = original;
      el.removeAttribute(ORIGINAL_ATTR);
    });
  }

  function applyTest() {
    if (applying) return;
    applying = true;

    try {
      var enabled = isAbEnabled() && !isConflictingTest();

      if (lastEnabled !== enabled) {
        lastEnabled = enabled;
      }

      document.body.classList.toggle('bundle-messaging-3pack-ab--active', enabled);

      if (!enabled) {
        restoreLabels();
        restoreDiscountBadges();
        document.querySelectorAll('[' + PACK_ATTR + ']').forEach(function (el) {
          if (!document.body.classList.contains('bundle-messaging-ab--active')) {
            el.removeAttribute(PACK_ATTR);
          }
        });
        return;
      }

      tagPackNodes();
      applyLabels();
      applyDiscountBadges();
    } finally {
      applying = false;
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(applyTest, 0);
  }

  function onPackPick(event) {
    if (!isAbEnabled() || isConflictingTest()) return;
    if (event.target.closest('.kaching-bundles__bar, .block-swatch, .bundle-perks')) {
      lastKachingInteraction = Date.now();
      tagPackNodes();
      applyLabels();
      applyDiscountBadges();
      requestAnimationFrame(function () {
        tagPackNodes();
        applyLabels();
        applyDiscountBadges();
      });
    }
  }

  function onVariantUpdate() {
    if (!isAbEnabled() || isConflictingTest()) return;
    tagPackNodes();
    applyLabels();
    applyDiscountBadges();
    schedule();
  }

  function init() {
    applyTest();

    document.addEventListener('click', onPackPick, true);
    document.addEventListener('variant:change', onVariantUpdate);
    document.addEventListener('product:rerender', onVariantUpdate);

    new MutationObserver(function (mutations) {
      if (applying) return;
      var run = false;
      mutations.forEach(function (m) {
        if (
          m.attributeName === ATTR ||
          m.attributeName === 'data-bundle-selector-ab' ||
          m.attributeName === 'data-bundle-messaging-ab'
        ) {
          run = true;
        }
      });
      if (run) schedule();
    }).observe(document.body, {
      attributes: true,
      attributeFilter: [ATTR, 'data-bundle-selector-ab', 'data-bundle-messaging-ab']
    });

    new MutationObserver(function (mutations) {
      if (applying) return;

      var run = false;
      mutations.forEach(function (m) {
        if (m.type !== 'childList' || !m.addedNodes.length) return;
        var i;
        var node;
        for (i = 0; i < m.addedNodes.length; i++) {
          node = m.addedNodes[i];
          if (node.nodeType !== 1) continue;
          if (
            (node.matches && node.matches('.kaching-bundles__bar, kaching-bundle, kaching-bundles, .bundletitle, .block-swatch, variant-picker')) ||
            (node.querySelector && node.querySelector('.kaching-bundles__bar, .bundletitle, .block-swatch--pack-1, .block-swatch--pack-2, .block-swatch--pack-4'))
          ) {
            run = true;
            break;
          }
        }
      });
      if (run) {
        tagPackNodes();
        applyLabels();
        applyDiscountBadges();
        schedule();
      }
    }).observe(document.body, { childList: true, subtree: true });

    [100, 400, 1000, 2500].forEach(function (ms) {
      setTimeout(applyTest, ms);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', applyTest);

  window.AerlessBundleMessaging3packAb = {
    refresh: applyTest,
    isEnabled: isAbEnabled,
    reset: function () {
      applyTest();
    }
  };
})();
